<template>
  <div>
    <CpTextEditor :text="text" :placeholder="placeholder" @sendMessage="sendMessage" :loadingSend="loading" />
  </div>
</template>

<script>
export default {
  name: 'CpOpinionInput',
  components: {
    capitalizeFirstLetter: require('../mixins/utils.js').default,
    CpTextEditor: require('../components/TextEditor').default,
  },
  props: {
    send: { type: Function },
    tag: Object,
    name: { type: String },
    currentUser: { type: Object, default: {} },
    placeholderStatusPost: { type: String },
    modalFeed: { type: Boolean, default: false },
  },
  data() {
    const placeholderText = this.name ? this.placeholderStatusPost : this.capitalizeFirstLetter(this.placeholderStatusPost);
    return {
      text: '',
      placeholder: this.name + ' ' + placeholderText,
      type: 'none',
      loading: false,
    };
  },
  methods: {
    async sendMessage(e, data) {
      e.preventDefault();
      this.loading = true;

      const tp = this.type;
      this.type = 'none';
      await this.send(tp, data);
      this.loading = false;
    },
  },
};
</script>